/**
 * YoutubeのURLであるか
 * @param url
 */
function isYoutube(url: string): boolean {
  return (
    url.startsWith("https://www.youtube.com/") ||
    url.startsWith("https://youtu.be/")
  );
}

/**
 * VimeoのURLであるか
 */
function isVimeo(url: string): boolean {
  return url.startsWith("https://vimeo.com/");
}

/**
 * YoutubeのURLを埋め込み用URLに変換
 */
function convertUrlYoutube(url: string): string | undefined {
  let id: string | null = null;
  if (url.startsWith("https://www.youtube.com/")) {
    const u = new URL(url);
    id = u.searchParams.get("v");
    if (!id) {
      if (
        url.includes("live") ||
        url.includes("shorts") ||
        url.includes("embed")
      ) {
        id = u.pathname.split("/")[2] ?? null;
      }
    }
  }

  if (url.startsWith("https://youtu.be/")) {
    const u = new URL(url);
    id = u.pathname.split("/")[1] ?? null;
  }

  if (!id) {
    return undefined;
  }

  return `https://www.youtube.com/embed/${id}`;
}

/**
 * VimeoのURLを埋め込み用URLに変換
 */
function convertUrlVimeo(url: string): string | undefined {
  const u = new URL(url);
  const path = u.pathname;
  const id = path.split("/")[1] ?? undefined;
  if (!id) {
    return undefined;
  }
  return `https://player.vimeo.com/video/${id}`;
}

/**
 * YoutubeまたはVimeoのURLを埋め込み用URLに変換
 */
export function embedUrl(url: string): string | undefined {
  if (isYoutube(url)) {
    return convertUrlYoutube(url);
  }
  if (isVimeo(url)) {
    return convertUrlVimeo(url);
  }
  return undefined;
}
